export default __webpack_public_path__ + "static/media/kitchen3-afterC-480w.86448ce1.png";